module.exports = __webpack_public_path__ + "media/Footprints/Waste-7950b5bb.svg";